import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";
import { PageExitAnimationGuard } from "./auth/page-exit-animation.guard";
// import { AnimateGuard } from './auth/animate.guard';

const routes: Routes = [
  {
    path: "",
    redirectTo: "accounts",
    pathMatch: "full",
  },
  {
    path: "onboarding",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./onboarding/onboarding.module").then(
        (m: any) => m.OnboardingPageModule
      ),
  },
  {
    path: "otp-verification",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./pages/otp-verification/otp-verification.module").then(
        (m: any) => m.OtpVerificationPageModule
      ),
  },
  {
    path: "reset-password",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/reset-password/reset-password.module").then(
        (m: any) => m.ResetPasswordPageModule
      ),
  },
  {
    path: "order",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order.module").then((m: any) => m.OrderPageModule),
  },
  {
    path: "calendar",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./calendar/calendar.module").then(
        (m: any) => m.CalendarPageModule
      ),
  },
  {
    path: "notifications",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./notifications/notifications.module").then(
        (m: any) => m.NotificationsPageModule
      ),
  },
  {
    path: "community",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./community/community.module").then(
        (m: any) => m.CommunityPageModule
      ),
  },
  {
    path: "accounts",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/accounts.module").then(
        (m: any) => m.AccountsPageModule
      ),
  },
  {
    path: "journey",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./journey/journey.module").then((m: any) => m.JourneyPageModule),
  },
  {
    path: "journey-result",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./journey/journey-result/journey-result.module").then(
        (m: any) => m.JourneyResultPageModule
      ),
  },
  {
    path: "profile",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/profile/profile.module").then(
        (m: any) => m.ProfilePageModule
      ),
  },
  {
    path: "loyalty",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/loyalty/loyalty.module").then(
        (m: any) => m.LoyaltyPageModule
      ),
  },
  {
    path: "news",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/news/news.module").then((m: any) => m.NewsPageModule),
  },
  {
    path: "consultation",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/consultation/consultation.module").then(
        (m: any) => m.ConsultationPageModule
      ),
  },
  {
    path: "celebrity",
    // canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./celebrity/celebrity.module").then(
        (m: any) => m.CelebrityPageModule
      ),
  },
  {
    path: "celebrity-subscription",
    // canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./celebrity-subscription/celebrity-subscription.module").then(
        (m: any) => m.CelebritySubscriptionPageModule
      ),
  },
  {
    path: "new-consultation",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import(
        "./accounts/consultation/new-consultation/new-consultation.module"
      ).then((m: any) => m.NewConsultationPageModule),
  },
  {
    path: "change-password",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/change-password/change-password.module").then(
        (m: any) => m.ChangePasswordPageModule
      ),
  },
  {
    path: "address-lists",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/address-lists/address-lists.module").then(
        (m: any) => m.AddressListsPageModule
      ),
  },
  {
    path: "my-subscriptions",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/my-subscriptions/my-subscriptions.module").then(
        (m: any) => m.MySubscriptionsPageModule
      ),
  },
  {
    path: "upgrade-subscription",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import(
        "./accounts/upgrade-subscription/upgrade-subscription.module"
      ).then((m: any) => m.UpgradeSubscriptionPageModule),
  },
  {
    path: "subscription-list",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/subscription-list/subscription-list.module").then(
        (m: any) => m.SubscriptionListPageModule
      ),
  },
  {
    path: "checkout",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/checkout/checkout.module").then(
        (m: any) => m.CheckoutPageModule
      ),
  },
  {
    path: "checkout-pending",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/checkout-pending/checkout-pending.module").then(
        (m: any) => m.CheckoutPendingPageModule
      ),
  },
  {
    path: "checkout-global",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./checkout-global/checkout-global.module").then(
        (m: any) => m.CheckoutGlobalPageModule
      ),
  },
  {
    path: "settings",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./accounts/settings/settings.module").then(
        (m: any) => m.SettingsPageModule
      ),
  },
  {
    path: "customer-details",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/customer-details/customer-details.module").then(
        (m: any) => m.CustomerDetailsPageModule
      ),
  },
  {
    path: "order-checkout",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order-checkout/order-checkout.module").then(
        (m: any) => m.OrderCheckoutPageModule
      ),
  },
  {
    path: "order-confirm/:id",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order-confirmed/order-confirmed.module").then(
        (m: any) => m.OrderConfirmedPageModule
      ),
  },
  {
    path: "order-failed/:id",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order-failed/order-failed.module").then(
        (m: any) => m.OrderFailedPageModule
      ),
  },
  {
    path: "order-history",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order-history/order-history.module").then(
        (m: any) => m.OrderHistoryPageModule
      ),
  },
  {
    path: "order-details/:id",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./order/order-details/order-details.module").then(
        (m: any) => m.OrderDetailsPageModule
      ),
  },
  {
    path: "menu-list",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./menu-list/menu-list.module").then(
        (m: any) => m.MenuListPageModule
      ),
  },
  {
    path: "menu",
    canActivate: [AuthGuard],
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./daily-menu/daily-menu.module").then(
        (m: any) => m.DailyMenuPageModule
      ),
  },
  {
    path: "payment",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./pages/payment/payment.module").then(
        (m: any) => m.PaymentPageModule
      ),
  },
  {
    path: "display-menu",
    canDeactivate: [PageExitAnimationGuard],
    loadChildren: () =>
      import("./display-menu/display-menu.module").then(
        (m: any) => m.DisplayMenuPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
